import React from "react";
import "./Ruko.scss";
import data from "./data.json";
import Card from "../../Component/Card Ruko/CardRuko";
import Braserrie2images from "../../Media/Produk/Ruko/Braserif2";
import Braserrie3images from "../../Media/Produk/Ruko/Braserif3";

const imageMap = {
  Braserrie2images,
  Braserrie3images,

  // Add other image arrays here if you have more sets
};

const produk = () => {
  return (
    <div id="ruko" className="produk">
      <h1>Our Ruko Commercials</h1>
      <h2>Cicilan Start 8 Juta/Bulan</h2>
      <div className="cardhome-containerf">
        {data.cards.map((card, index) => {
          // Determine the logo dynamically
          // Determine the logo dynamically
          return (
            <Card
              key={index}
              carousel={imageMap[card.imagesKey]}
              title={card.title}
              subtitle={card.subtitle}
              price={card.price}
              subprice={card.subprice}
              details={card.details}
              whatsappLink={card.whatsappLink} // Pass the WhatsApp link
            />
          );
        })}
      </div>
    </div>
  );
};

export default produk;
